"use client"
import React, { useEffect, useState } from "react"
import { TextShimmer } from "./text-shimmer"
import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"
import { useTranslation } from "react-i18next"

interface RotatingTextShimmerProps {
  className?: string
  messages?: string[]
  interval?: number
}

// Keys, translated at render.
const defaultMessageKeys = [
  "app.ui.orderProgress.analyzing",
  "app.ui.orderProgress.extracting",
  "app.ui.orderProgress.processing",
  "app.ui.orderProgress.calculating",
  "app.ui.orderProgress.searching",
  "app.ui.orderProgress.optimizing",
] as const

export function RotatingTextShimmer({
  className,
  messages: customMessages,
  interval = 3000,
}: RotatingTextShimmerProps) {
  const { t } = useTranslation()
  const messages = customMessages ?? defaultMessageKeys.map((key) => t(key))
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length)
    }, interval)

    return () => clearInterval(timer)
  }, [messages.length, interval])

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Loader2 className="h-4 w-4 animate-spin text-blue-500" />
      <TextShimmer className="text-sm font-medium" duration={2}>
        {messages[currentIndex]}
      </TextShimmer>
    </div>
  )
}
